import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface BootQueryParams {
  /** 正序 */
  asc?: boolean
  /** 启动项类型 */
  autorun_type?: number
  /** 搜索关键词 */
  key_word?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 排序字段 */
  sort?: string
}

export interface BootItem {
  soft_name: string // 启动项名
  description: string // 描述row
  app_name: string // 应用名称
  autorun_type: number // 启动类型
  suggest_action: number // 建议操作
  optimize_count: number // 已优化终端数
  not_optimize_count: number // 未优化终端数
  autorun_hash: string // 启动项hash
}

export interface DetailQueryParams {
  autorun_hash: string // 启动项名称
  optimize_type: number // 优化类型，1-已优化终端,2-未优化终端
  /** 与接口 `terminal/start-item/list` 一致：页码、每页条数 */
  page: number
  limit: number
}

export interface DetailItem {
  device_id: string // 终端id
  computer_name: string // 计算机名
  user_mark: string // 登记用户信息
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  intercept_time: number // 拦截时间
  login_status: number // 登录状态,1-在线，2-离线
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}

export interface OptimizeOption {
  autorun_list: string[],
  recovery: boolean
}

export interface TrustOption {
  autorun_list: string[],
  trust: boolean
}

@Injectable()
export class BootViewService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  fetchBootList (options: BootQueryParams) {
    return this.http
      .post<{
        total: number,
        list: BootItem[]
      }>('terminal/start-item/stat', options)
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchDetailList (options: DetailQueryParams) {
    return this.http
      .post<{
        total: number,
        list: DetailItem[]
      }>('terminal/start-item/list', options)
  }

  @InvokeThrottle()
  optimizeOrder (option: OptimizeOption) {
    return this.http
      .post<{
        task_id: string // 任务id
        terminal_count: number // 优化终端数
      }>('/terminal-order/autorun-optimize', option)
  }

  @InvokeThrottle()
  trustOrder (option: TrustOption) {
    return this.http
      .post('/terminal-order/autorun-trust', option)
  }
}
